import firstWorkData from './data/firstWork';
import secondWorkData from './data/secondWork';


export type IWorkPreset = {
  name: string;
  data: string;
};

const preset: Record<string, string> = {
  first: firstWorkData,
  second: secondWorkData



}

export default preset;
